import React from 'react';

import { useFormContext, useWatch } from 'react-hook-form';

import { LbInput, ReadOnlyInput, InputAdornment } from '@infoods/lifebase-ui';
import classes from './MealRow.module.scss';
import { Nutrient } from '../../../../../../../shared/components/ui-components';
import {
  GridTableCell,
  GridTableRow,
} from '../../../../../../../shared/components/table-components';
import { NUTRIENTS_ENUM } from '../../../../../../../shared/constants/NUTRIENTS_ENUM';
import { calculateMealCalories } from '../../../../../../../shared/utils/mealUtils';
import { WorkoutMealsFormValues } from '../WorkoutMeals.settings';
import { validateNegativeNumber } from '../../../../../../../shared/utils/reactHookFormUtils';

type MealRowProps = {
  title: string;
  mealFromKey: 'preWorkout' | 'postWorkout'; // create a type for this
};

const nutrientsList = [
  NUTRIENTS_ENUM.PROTEINS,
  NUTRIENTS_ENUM.CARBS,
  NUTRIENTS_ENUM.FATS,
] as const;

// TODO fold into nutrition's shared MealRow once its mealFormKey binds a generic Path<TForm>
const MealRow = ({ title, mealFromKey }: MealRowProps) => {
  const { control } = useFormContext<WorkoutMealsFormValues>();
  const nutrientsInputsSetting = nutrientsList.map(
    (nutrient) =>
      ({
        name: `workoutMeals.${mealFromKey}.${nutrient}`,
        nutrient,
      }) as const,
  );

  const [proteins, carbs, fats] = useWatch({
    control,
    name: nutrientsInputsSetting.map((nutrient) => nutrient.name),
  });

  const calories = calculateMealCalories({ proteins, carbs, fats });

  return (
    <GridTableRow variant="unstyled" className={classes.row}>
      <GridTableCell variant="title">{title}</GridTableCell>
      {nutrientsInputsSetting.map(({ name, nutrient }) => (
        <GridTableCell className={classes.cell} key={nutrient}>
          <LbInput
            control={control}
            name={name}
            size="small"
            type="number"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Nutrient nutrient={nutrient} />
                </InputAdornment>
              ),
            }}
            rules={{ validate: { validateNegativeNumber } }}
          />
        </GridTableCell>
      ))}
      <GridTableCell>
        <Nutrient nutrient="calories">
          <ReadOnlyInput
            control={control}
            name={`workoutMeals.${mealFromKey}.calories`}
            value={calories}
          />
        </Nutrient>
      </GridTableCell>
    </GridTableRow>
  );
};

export { MealRow };
